import React from 'react';
import Section from '../ui/Section';
import Heading from '../ui/Heading';
import Card from '../ui/Card';

const MissionVision = () => {
  return (
    <Section className='py-6 sm:py-10 sm:px-5 lg:px-10'>
      <div className="text-center mb-12">
        <Heading level={2} className=''>Our Mission & Vision</Heading>
        <p className="text-gray-700 max-w-3xl mx-auto">
          At Vasudharini, we're guided by a clear mission and a long-term vision that shapes every project we undertake.
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <Card className="p-8">
          <div className="h-16 w-16 bg-yellow-500 rounded-full flex items-center justify-center mb-6">
            <svg className="h-8 w-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          
          <Heading level={3}>Our Mission</Heading>
          <p className="text-gray-700 mb-4">
            To develop and deliver affordable housing projects that meet the highest standards of quality and design, 
            ensuring that every home we build reflects our commitment to excellence.
          </p>
          
          <ul className="space-y-2 text-gray-700">
            <li className="flex items-start">
              <svg className="h-5 w-5 text-yellow-500 mt-0.5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Develop projects that balance affordability with luxury
            </li>
            <li className="flex items-start">
              <svg className="h-5 w-5 text-yellow-500 mt-0.5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Create homes that meet the evolving needs of modern families
            </li>
            <li className="flex items-start">
              <svg className="h-5 w-5 text-yellow-500 mt-0.5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Implement innovative ideas for sustainability in each project
            </li>
          </ul>
        </Card>
        
        <Card className="p-8">
          <div className="h-16 w-16 bg-yellow-500 rounded-full flex items-center justify-center mb-6">
            <svg className="h-8 w-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          </div>
          
          <Heading level={3}>Our Vision</Heading>
          <p className="text-gray-700 mb-4">
            To be an industry leader in developing exceptional projects that not only provide shelter but also 
            enhance the quality of life for our residents, contributing positively to the urban landscape of Bangalore.
          </p>
          
          <ul className="space-y-2 text-gray-700">
            <li className="flex items-start">
              <svg className="h-5 w-5 text-yellow-500 mt-0.5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Become a trusted name in the real estate sector
            </li>
            <li className="flex items-start">
              <svg className="h-5 w-5 text-yellow-500 mt-0.5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Create sustainable communities that appreciate in value
            </li>
            <li className="flex items-start">
              <svg className="h-5 w-5 text-yellow-500 mt-0.5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Establish new benchmarks for quality in affordable housing
            </li>
          </ul>
        </Card>
      </div>
    </Section>
  );
};

export default MissionVision;